import { View } from "@aws-amplify/ui-react";
import SymptomsIcon from "./SymptomsIcon";

export default function SymptomsComponent() {
  return (
    <View
      width="50px"
      height="50px"
      display="block"
      gap="unset"
      alignItems="unset"
      justifyContent="unset"
      overflow="hidden"
      shrink="0"
      position="relative"
      padding="0px 0px 0px 0px"
    >
      <SymptomsIcon />
    </View>
  );
}
